<!-- eslint-disable max-lines -->
<template #items="props">
  <div
    :class="[
      'sb-base-table sb-base-table2',
      fullHeightTable ? 'sb_full_height_table' : '',
    ]"
  >
    <v-dialog v-model="dialog" max-width="500px" persistent>
      <v-card>
        <v-card-text>
          <v-layout>
            <v-flex> {{ alertMessage }} </v-flex>
            <div>
              <v-icon class="c-pointer" @click="dialog = false"> close </v-icon>
            </div>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!--download and columnFilterable functionality -->

    <slot
      name="above-table"
      :items="items"
      :total-items="totalItems"
      :selected-items="selectedItems"
      :current-page="currentPage"
      :extra-response-properties="extraResponseProperties"
      :displayedColumns="displayedColumns"
      :allColumns="allColumns"
      :filteredItems="filteredItems"
    />
    <v-layout>
      <v-flex>
        <slot
          name="top-actions"
          :items="items"
          :selected-items="selectedItems"
          :current-page="currentPage"
          :extra-response-properties="extraResponseProperties"
        />
      </v-flex>
      <div
        v-if="columnFilterable || downloadable"
        class="UDM_GS_HeaderIcons d-flex align-center"
      >
        <v-btn
          v-if="columnFilterable"
          :id="`${tableId}-btn-filter_list`"
          icon
          flat
          depressed
          fab
          :disabled="disableFiltersButton"
          @click="headerColumntoggle"
        >
          <v-tooltip top>
            <template v-slot:activator="{ on, attr }">
              <v-icon
                class="material-icons-round filter-list"
                v-bind="attr"
                v-on="on"
                >filter_list</v-icon
              >
            </template>
            <span> Choose which table columns to display </span>
          </v-tooltip>
        </v-btn>
        <v-btn
          v-if="downloadable"
          :id="`${tableId}-btn-download`"
          icon
          flat
          depressed
          fab
          class="mr-0"
          :disabled="disableDownloadButton"
          @click="exportFullTable"
        >
          <v-tooltip top>
            <template v-slot:activator="{ on, attr }">
              <v-icon
                class="material-icons-round base-card-download"
                v-bind="attr"
                v-on="on"
                >download</v-icon
              >
            </template>
            <span> Download this table as a CSV file </span>
          </v-tooltip>
        </v-btn>
      </div>
    </v-layout>

    <!-- Column expand arrow -->
    <v-row
      v-if="showColumnsHeader && !hideColumnToggleBtn"
      class="sb_expand_column_header d-flex"
    >
      <v-col class="text-center col-12">
        <v-tooltip top>
          <template v-slot:activator="{ on, attr }">
            <v-btn depressed fab small v-bind="attr" v-on="on">
              <v-icon
                v-show="expandColumnHeader === false"
                medium
                @click="headerColumntoggle"
              >
                arrow_drop_down
              </v-icon>
              <v-icon
                v-show="expandColumnHeader === true"
                small
                @click="headerColumntoggle"
              >
                close
              </v-icon>
            </v-btn>
          </template>
          <span>Columns</span>
        </v-tooltip>
        <v-divider />
      </v-col>
    </v-row>
    <!-- Column Button -->
    <div v-if="expandColumnHeader">
      <v-layout row wrap class="sb_columns_container">
        <v-btn
          v-for="(column, columnIndex) in allColumns.filter((c) => !c.hidden)"
          :id="`${removeSpecialCharacters(column.source)}_Header`"
          :key="columnIndex"
          :title="column.tooltip"
          :color="column.visible ? undefined : 'outline'"
          :dark="column.visible"
          selected
          @click.stop="columnSelection(column)"
        >
          {{ column.rename || column.source }}
        </v-btn>
        <div v-if="$store.getters.userIsAdmin" class="pt-1">
          <a
            :href="`${SbBaseUrl}/Admin/#/table-controls/${tableKey}`"
            target="_blank"
            class="caption pa-2"
          >
            Configure this table
          </a>
        </div>
      </v-layout>
    </div>
    <div :class="['sb-mc-table__wrapper', tableId]">
      <table :id="tableId" class="sb-mc-table v-datatable v-table">
        <thead>
          <tr>
            <th
              v-if="selectable && !hideSingleSelectCheckbox"
              class="sb_table_selectAll_checkbox"
            >
              <filter-header hide-filter-input single-icon>
                <v-checkbox
                  v-if="!singleSelection"
                  :input-value="selectedIds.length === items.length"
                  :indeterminate="selectedIds.length > 0"
                  :disabled="singleSelection"
                  primary
                  hide-details
                  class="ml-2 pt-3"
                  @click.stop="toggleSelectAll"
                />
              </filter-header>
            </th>
            <slot name="header-left" />
            <th
              v-for="(column, columnIndex) in displayedColumns"
              :key="columnIndex"
              :title="column.tooltip"
              :class="{ count_column: column.type !== 'text' }"
            >
              <filter-header
                :key="filters[column.source]"
                v-model="filters[column.source]"
                :label="column.rename || column.source"
                :type="column.type"
                :clear-inputs="clearInputs"
                :filter-type="filterTypes[column.source]"
                :is-sorted="sorting.sortColumn === column.source"
                :sort-dir="
                  sorting.sortColumn === column.source
                    ? sorting.sortDirection
                    : 'default'
                "
                :value="filters[column.source]"
                :previous-header-name="previousHeader"
                @toggleInput="toggleInput"
                @change:header="(e) => updatePreviousHeader(e)"
                @updated:sort="
                  (sortDirection) =>
                    (sorting = { sortColumn: column.source, sortDirection })
                "
                @updated:filter="
                  (value) => $set(filterTypes, column.source, value)
                "
              />
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-if="items.length === 0">
            <td
              :colspan="
                displayedColumns.length +
                (selectable ? 1 : 0) +
                (extraColumn ? 1 : 0)
              "
            >
              <v-alert :value="loading" type="info"> Loading... </v-alert>
              <v-alert :value="!loading" type="info">
                <slot name="no-data"> No items to show </slot>
              </v-alert>
            </td>
          </tr>
          <tr
            v-for="(item, itemIndex) in items"
            :key="itemIndex"
            :class="[
              selectable ? 'c-pointer' : '',
              selectedIds.includes(item[selectItemKey]) && addActiveClass
                ? 'active'
                : '',
              selectedIds.includes(item[selectItemKey])
                ? ''
                : backgroundColorFunction(item),
            ]"
            @click="toggleSelection(item)"
          >
            <td
              v-if="selectable && !hideSingleSelectCheckbox"
              class="sb_table_checkbox"
            >
              <v-checkbox
                v-if="item.selectable !== false"
                :input-value="selectedIds.includes(item[selectItemKey])"
                primary
                hide-details
                :disabled="item.selectable === false"
                class="mt-0 mc-table-select"
              />
              <v-icon v-else :title="item.noSelectMessage">
                {{ item.noSelectIcon || SbIcons.status.warn }}
              </v-icon>
            </td>
            <slot name="body-left" :item="item" :items="items" />
            <td
              v-for="(column, columnIndex) in displayedColumns"
              :key="columnIndex"
            >
              <slot
                :name="`${column.source}-body`"
                :value="item[column.source]"
                :item="item"
              >
                {{ getDisplayValue(item[column.source], column.type) }}
              </slot>
            </td>
          </tr>
        </tbody>
        <tfoot>
          <tr>
            <td
              :colspan="
                displayedColumns.length +
                (selectable ? 1 : 0) +
                (extraColumn ? 1 : 0)
              "
            ></td>
          </tr>
        </tfoot>
      </table>
    </div>
    <v-layout row>
      <!-- Pagination Controls -->
      <v-flex xs12 class="text-xs-center caption sb_mc_table_footer">
        <span
          v-if="
            selectable && selectedItems.length > 0 && !hideSelectedItemsCount
          "
          class="sb_table_selected_items_count"
        >
          {{ selectedItems.length }} item{{
            selectedItems.length > 1 ? 's' : ''
          }}
          selected
        </span>

        <template v-if="totalItems > initialPageSize">
          <!-- <span>{{totalItems.length}}</span> -->
          <span class="pr-2"> Rows per page: </span>
          <span class="pr-2">
            <v-select
              :id="`${tableId}_RowsPerPage`"
              v-model="pagination.pageSize"
              :items="pageSizeOptions"
              class="ma-0 pt-0 page-size-select"
            />
          </span>
          <span>
            {{ currentPageDescription }}
            <v-btn
              :id="`${tableId}_PrevPage`"
              flat
              :disabled="pagination.page === 0"
              @click.stop="pagination.page -= 1"
            >
              <v-icon>chevron_left</v-icon>
            </v-btn>
            <v-btn
              :id="`${tableId}_NextPage`"
              flat
              :disabled="
                (pagination.page + 1) * pagination.pageSize >= filteredItems
              "
              @click.stop="pagination.page += 1"
            >
              <v-icon>chevron_right</v-icon>
            </v-btn>
          </span>
        </template>
      </v-flex>
    </v-layout>
    <slot
      name="below-table"
      :items="items"
      :selected-items="selectedItems"
      :current-page="currentPage"
      :extra-response-properties="extraResponseProperties"
    />
  </div>
</template>

<script>
/**
 * This is a table component where the column configuration is controlled by the site admin
 * - Columns names/tooltips/ordering all handled via internally config
 * - Table controls always enabled
 * - Always filterable/sortable/selectable
 * - Always dense layout, this table will generally be used for tables with a lot of data
 * - Always using server-side paging to supply data one page at a time
 */
import columnTypes from '../static/tables/columnTypes.js';
import { tables } from '../static/tables/index.js';
import { post } from '../utility/fetch.js';
import FilterHeader from './BaseTable/FilterHeader.vue';
import typeDisplay from './BaseTable/typeDisplay.mixin.js';
import { exportCsv } from '../utility/export.js';
import { debounce } from '../utility/debounce.js';
import { renderFileSize } from '../utility/ConvertNumber.js';

export default {
  name: 'ManagedConfigurationTable',
  components: { FilterHeader },
  mixins: [typeDisplay],
  props: {
    tableKey: {
      type: String,
      required: true,
      validator(value) {
        return tables.map((t) => t.key).includes(value);
      },
    },
    tableId: {
      type: String,
      default() {
        return 'ManagedConfigurationTable';
      },
    },
    disableFiltersButton: {
      type: Boolean,
    },

    disableDownloadButton: {
      type: Boolean,
    },
    hideColumnToggleBtn: {
      type: Boolean,
    },
    fullHeightTable: {
      type: Boolean,
    },
    filterColumnWithType: {
      type: [Array],
      default() {
        return [];
      },
    },
    belowTableElementsHeight: {
      type: Number,
      default() {
        return 0;
      },
    },
    existingItems: {
      type: [Array],
      default() {
        return [];
      },
    },
    apiEndpoint: {
      type: String,
      required: true,
    },
    selectItemKey: {
      type: String,
      default() {
        return undefined;
      },
    },
    urlFilterKey: {
      type: String,
      default() {
        return 'filters';
      },
    },
    urlFilterTypesKey: {
      type: String,
      default() {
        return 'filterTypes';
      },
    },
    initialPageSize: {
      type: Number,
      default() {
        return 10;
      },
    },
    preventLoading: {
      type: Boolean,
    },
    singleSelection: {
      type: Boolean,
    },
    hideSingleSelectCheckbox: {
      type: Boolean,
    },
    hideSelectedItemsCount: {
      type: Boolean,
    },
    disableDownload: {
      type: Boolean,
    },
    disableRouteFilters: {
      type: Boolean,
    },
    tableOptions: {
      type: Boolean,
    },
    extraColumn: {
      type: Boolean,
    },
    excludeItemsWithKey: {
      type: String,
      default() {
        return undefined;
      },
    },
    excludeTextKey: {
      type: Boolean,
    },
    showColumnsHeader: {
      type: Boolean,
    },
    triggerSelection: {
      type: Boolean,
    },
    reloadPage: {
      type: Boolean,
    },
    addActiveClass: {
      type: Boolean,
    },
    downloadable: {
      type: Boolean,
    },
    columnFilterable: {
      type: Boolean,
    },
    backgroundColorFunction: {
      type: Function,
      default() {
        return function () {
          return '';
        };
      },
    },
  },
  data() {
    return {
      items: [],
      totalItems: 0,
      filteredItems: 0,
      extraResponseProperties: {},
      notSelectableItems: [],
      pagination: {
        page: 0,
        pageSize: 10,
      },
      sorting: {
        sortColumn: undefined,
        sortDirection: undefined,
      },
      pageSizeOptions: [5, 10, 25, 50, 100],
      selectedIds: [],
      filters: {},
      filterTypes: {},
      previousHeader: null,
      loading: false,
      selectedItems: [],
      removeSelections: true,
      clearInputs: false,
      expandColumnHeader: false,
      dialog: false,
      alertMessage: 'You must select at least one column',
      mounted: false,
    };
  },
  computed: {
    tableConfig() {
      const config = this.$store.getters.tableConfigs.filter(
        (t) => t.key === this.tableKey
      )[0];
      const emptyConfig = {
        [columnTypes.default.key]: [],
        [columnTypes.extra.key]: [],
        [columnTypes.hidden.key]: [],
      };
      return config || emptyConfig;
    },
    allColumns() {
      const defaultColumns = this.tableConfig[columnTypes.default.key].map(
        (c) => {
          this.$set(c, 'visible', true);
          this.$set(c, 'hidden', false);
          return c;
        }
      );
      const extraColumns = this.tableConfig[columnTypes.extra.key].map((c) => {
        this.$set(c, 'visible', false);
        this.$set(c, 'hidden', false);
        return c;
      });
      const hiddenColumns = this.tableConfig[columnTypes.hidden.key].map(
        (c) => {
          this.$set(c, 'visible', false);
          this.$set(c, 'hidden', true);
          return c;
        }
      );
      let all = [...defaultColumns, ...extraColumns, ...hiddenColumns].map(
        (c) => {
          this.$set(c, 'type', c.type || 'text');
          return c;
        }
      );
      all.sort((a, b) => a.order - b.order);
      return all;
    },
    displayedColumns() {
      return this.allColumns.filter((c) => c.visible);
    },
    currentPageDescription() {
      const startIndex = this.pagination.page * this.pagination.pageSize;
      var endIndex = startIndex + this.pagination.pageSize;
      if (endIndex > this.filteredItems) {
        endIndex = this.filteredItems;
      }
      let description = `Showing ${startIndex + 1}-${endIndex} of ${
        this.filteredItems
      }`;
      if (this.totalItems !== this.filteredItems) {
        description = `${description} (filtered from ${this.totalItems})`;
      }
      return description;
    },
    selectable() {
      return this.selectItemKey !== undefined;
    },
    filterArray() {
      if (this.disableRouteFilters) {
        return [];
      }
      // get all filter types with values
      let filterArr = Object.entries(this.filters).map(
        ([column, filterValue]) => {
          const type = this.allColumns.filter((c) => c.source === column)[0]
            .type;
          const filterType =
            this.filterTypes[column] ||
            (this.filterColumnWithType.length > 0 &&
            this.filterColumnWithType.map((x) => x.columnName).includes(column)
              ? this.filterColumnWithType.filter(
                  (x) => x.columnName == column
                )[0].filterType
              : 'contains');
          return { column, type, filterValue, filterType };
        }
      );
      // add in filter types that don't need a value
      for (let [column, filterType] of Object.entries(this.filterTypes)) {
        if (this.filters[column] !== undefined) continue;
        if (filterType !== 'empty') continue;
        const type = this.allColumns.filter((c) => c.source === column)[0].type;
        filterArr.push({ column, type, filterValue: '', filterType });
      }
      return filterArr;
    },
    currentPage() {
      const { sorting, pagination } = this;
      return {
        filters: this.filterArray,
        sorting,
        pagination,
      };
    },
    loadPageDebounce() {
      if (!this.mounted) {
        return () => {}; // return value must be a method
      }
      let obj = {
        columns: this.allColumns,
        currentPage: this.currentPage,
      };
      this.$emit('getPageConfigs', obj);
      return debounce(this.loadPage, 250);
    },
  },
  watch: {
    pagination: {
      deep: true,
      handler() {
        this.removeSelections = false;
        this.loadPageDebounce();
      },
    },
    sorting: {
      deep: true,
      handler() {
        this.removeSelections = false;
        this.loadPageDebounce();
      },
    },
    filters: {
      deep: true,
      handler() {
        this.removeSelections = false;
        this.loadPageDebounce();
      },
    },
    filterTypes: {
      deep: true,
      handler() {
        this.removeSelections = false;
        this.loadPageDebounce();
      },
    },
    tableKey: {
      handler() {
        this.loadPageDebounce();
      },
    },
    apiEndpoint: {
      handler() {
        this.loadPageDebounce();
      },
    },
    preventLoading(newValue) {
      if (newValue === false) {
        this.loadPageDebounce();
      }
    },
    reloadPage() {
      if (this.reloadPage) {
        this.loadPageDebounce();
        this.$emit('reloadPage');
      }
    },
    existingItems: {
      handler() {
        this.loadPageDebounce();
      },
    },
  },
  created() {
    this.pagination.pageSize = Number(this.initialPageSize);
  },
  async mounted() {
    this.filterTypes = this.getObjectFromUrlQueryKey(this.urlFilterTypesKey);

    if (!this.$store.getters.tableConfigsLoaded) {
      await this.$store.dispatch('LOAD_COLUMN_CONFIGS');
    }
    this.filters = this.getObjectFromUrlQueryKey(this.urlFilterKey);
    this.displayFilteredColumns();
    this.mounted = true;
    this.loadPageDebounce();
    this.$nextTick(() => {
      this.$emit('pageLoaded');
    });
  },
  updated() {
    if (this.fullHeightTable) {
      this.setTableHeight();
    }
  },
  methods: {
    setTableHeight() {
      let tablePositionTop = document
          .querySelector(
            '.sb_full_height_table.sb-base-table .sb-mc-table__wrapper.' +
              this.tableId
          )
          .getBoundingClientRect().top,
        tableFooterHeight = document.querySelector(
          '.sb_full_height_table.sb-base-table .sb_mc_table_footer'
        ).offsetHeight,
        spacingBelowCard = 28 + Number(this.belowTableElementsHeight),
        applicationFooterHeight =
          document.querySelector('footer.v-footer').clientHeight,
        calculatedHeight =
          'calc(100vh - ' +
          (tablePositionTop +
            tableFooterHeight +
            spacingBelowCard +
            applicationFooterHeight) +
          'px)';
      document.querySelector(
        '.sb_full_height_table.sb-base-table .sb-mc-table__wrapper.' +
          this.tableId
      ).style.maxHeight = calculatedHeight;
    },
    updateExcludeTextKey(rowObj) {
      this.$emit('updateTooltip', rowObj);
    },
    async loadPage() {
      if (this.preventLoading) return;
      this.loading = true;
      this.clearInputs = false;
      const { totalCount, filteredCount, items, ...extra } = await post(
        this.apiEndpoint,
        this.currentPage
      );
      if (this.removeSelections) {
        this.resetSelections();
      }
      this.removeSelections = true;
      this.items = items;
      this.items = this.items.map((a) => {
        if (this.existingItems.includes(a[this.selectItemKey])) {
          a.selectable = false;
          a.noSelectMessage = `This item cannot be selected`;
        }
        if (a[this.excludeItemsWithKey]) {
          a.selectable = false;
          if (this.excludeTextKey) {
            this.updateExcludeTextKey(a);
          } else {
            a.noSelectMessage = `This item cannot be selected`;
          }
        }
        return a;
      });
      this.totalItems = totalCount;
      this.filteredItems = filteredCount;
      this.extraResponseProperties = extra;
      this.notSelectableItems = this.items.filter((i) => {
        if (i.selectable === false) {
          return i;
        }
      });
      const pageStartIndex = this.pagination.page * this.pagination.pageSize;
      if (pageStartIndex > this.filteredItems) {
        // when the data refreshes check if the current page is out of bounds for the new data and move to the first page if it is
        this.pagination.page = 0;
      }
      this.loading = false;
      this.$emit('tableLoaded');
    },
    headerColumntoggle() {
      this.expandColumnHeader = !this.expandColumnHeader;
    },
    toggleSelection(item) {
      if (item.selectable !== false) {
        const key = item[this.selectItemKey];
        if (this.singleSelection) {
          this.selectedItems = [item];
          this.selectedIds = [key];
          if (this.triggerSelection) {
            this.$emit('rowSelected', this.selectedItems);
          }
          return;
        }
        const keyIndex = this.selectedItems.findIndex(
          (x) => x[this.selectItemKey] === key
        );
        if (keyIndex !== -1) {
          this.selectedItems.splice(keyIndex, 1);
        } else {
          this.selectedItems.push(item);
        }
      } else {
        return;
      }
      this.selectedIds =
        this.selectedItems.length > 0
          ? this.selectedItems
              .filter((x) => !!x)
              .map((x) => x[this.selectItemKey])
          : [];
      if (this.triggerSelection) {
        this.$emit('rowSelected', this.selectedItems);
      }
    },
    toggleSelectAll() {
      if (
        this.selectedItems.length >=
        this.items.length - this.notSelectableItems.length
      ) {
        this.selectedItems = [];
      } else {
        this.selectedItems = this.items.filter((i) => {
          if (i.selectable !== false) {
            return i;
          }
        });
      }
      this.selectedIds =
        this.selectedItems.length > 0
          ? this.selectedItems
              .filter((x) => !!x)
              .map((x) => x[this.selectItemKey])
          : [];
      if (this.triggerSelection) {
        this.$emit('rowSelected', this.selectedItems);
      }
    },
    async exportFullTable() {
      this.loading = true;
      let page = JSON.parse(JSON.stringify(this.currentPage));
      page.pagination.page = 0;
      page.pagination.pageSize = 1000000; // get up to 1M rows
      const { items } = await post(this.apiEndpoint, page);
      const displayedKeys = this.displayedColumns.map((c) => c.source);
      const headers = this.displayedColumns.map((c) => c.rename || c.source);
      const body = items.map((i) =>
        displayedKeys.map((k) => {
          //will check column header contains text 'size' or not for udm granular table
          if (
            k.toLowerCase().includes('size') &&
            this.tableKey == 'udm-granular-page'
          )
            return renderFileSize(i[k]);
          else return i[k];
        })
      );
      exportCsv([headers, ...body], this.tableKey);
      this.loading = false;
    },
    getObjectFromUrlQueryKey(key) {
      if (key === undefined) return {};
      const objectString = this.$route.query[key];
      if (objectString === undefined) return {};
      return JSON.parse(decodeURIComponent(objectString));
    },
    displayFilteredColumns() {
      const filteredColumns = [
        ...new Set(
          Object.keys({
            ...this.filters,
            ...this.filterTypes,
          })
        ),
      ];
      this.allColumns.map((c) => {
        if (filteredColumns.includes(c.source)) {
          c.visible = true;
          c.hidden = false;
        }
      });
    },
    resetSelections() {
      this.selectedIds = [];
      this.selectedItems = [];
    },
    clearFilters() {
      this.clearInputs = true;
    },
    clearAll() {
      this.items = [];
      this.resetSelections();
      this.clearFilters();
      this.totalItems = 0;
      this.filteredItems = 0;
    },
    toggleInput() {
      this.clearInputs = false;
    },
    checkSelection(val) {
      return this.selectedItems.some((x) => x[this.selectItemKey] === val);
    },
    removeSpecialCharacters(str) {
      return str
        .replace(/(?!\w|\s)./g, '')
        .replace(/\s+/g, '')
        .replace(/^(\s*)([\W\w]*)(\b\s*$)/g, '$2');
    },
    updatePreviousHeader(column) {
      this.previousHeader = column;
    },
    columnSelection(selectedColumn) {
      let visibleColumns = this.allColumns.filter(
        (c) => c.visible && !c.hidden
      );
      if (
        visibleColumns.length == 1 &&
        visibleColumns[0].source == selectedColumn.source
      ) {
        this.dialog = true;
      } else {
        selectedColumn.visible = !selectedColumn.visible;
      }
    },
  },
};
</script>
<style>
@import '../static/css/SPHERETable.css';
</style>
